export default __webpack_public_path__ + "c4b3b4bd2dfad1b677b2fd5cf61c8fb8.jpg";